module.exports = __webpack_public_path__ + "img/edge_activites_rando.a2f16952.svg";